import { getExportableAnnotationsConfig } from '../../../core/components/annotations/utils/get-exportable-annotations-config.js';
import { ChartType } from '../../../core/types/chart-types.js';
import type { ResolvedTimeseriesChartConfig } from '../types/timeseries.js';

/**
 * Produces the same Timeseries-shaped serialized config payload as the
 * legacy `TimeseriesChartImperativeHandler.getConfig()`.
 *
 * This is the single source of truth for the export shape consumed by the
 * `TimeseriesChartConfig` import API and `TimeseriesChartRef.getConfig()`.
 *
 * Duplicates the flattening logic from the legacy `normalizeConfig` rather
 * than importing it, to keep the adoption layer decoupled from
 * `../../../timeseries`.
 */
export const serializeTimeseriesConfig = (
  config: ResolvedTimeseriesChartConfig,
): string => {
  const { thresholds, annotations, ...rest } = config;

  const yAxisEntries = [config.yAxis.left, config.yAxis.right];
  const yAxis = yAxisEntries.filter(
    (axis): axis is NonNullable<(typeof yAxisEntries)[number]> =>
      axis !== undefined,
  );

  const thresholdIndicators = thresholds
    ? [...(thresholds.left ?? []), ...(thresholds.right ?? [])]
    : undefined;

  return JSON.stringify({
    type: ChartType.TimeSeries,
    ...rest,
    yAxis,
    thresholdIndicators,
    annotations: getExportableAnnotationsConfig(annotations),
  });
};
